import { toast } from '@prophecy/ui-v3/LegacyToast';
import { useMemo } from 'react';

import { fetchTranspilerPaths } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';
import { FolderUploadTypes } from './Import/steps/types';

export const useUploadedFilePaths = (
  transpilerId: string,
  path: string,
  enabled: boolean,
  setPathToUpdate: (path: string) => void
) => {
  const { data, isLoading, isError } = useRestQuery(
    [QueryKey, transpilerId, 'fetchFilePaths'],
    () => fetchTranspilerPaths(transpilerId),
    {
      enabled,
      refetchOnMount: true,
      retry: false,
      onSuccess: () => {
        if (path === FolderUploadTypes.move) {
          toast.success({ content: 'Source moved successfully.' });
        }
        setPathToUpdate('');
      },
      onError: () => {
        setPathToUpdate('');
      }
    }
  );

  const paths = useMemo(() => data?.data || [], [data]);

  return { paths, isLoading, isError };
};
